import "./styles.scss";

import classnames from "classnames";

import { ReactComponent as CheckmarkIcon } from "assets/icons/new/check.svg";
import { ReactComponent as ArrowIcon } from "assets/icons/new/forward-arrow.svg";

const mainClass = `new-website-content__choose-plan__feature`;

const Feature = ({ label, value, onClick }) => {
  if (!label) return null;

  return (
    <button
      className={classnames(mainClass, { [`${mainClass}--active`]: !!value })}
      type="button"
      disabled={!!!onClick}
      onClick={onClick}
    >
      <i>
        <CheckmarkIcon />
      </i>
      <strong>{label}</strong>
      <span>{value ?? "-"}</span>
      {!!onClick && (
        <i>
          <ArrowIcon />
        </i>
      )}
    </button>
  );
};

export default Feature;
